import React, { useState, useEffect } from "react";
import { Select, Button, Card, message } from "antd";
import ComponentConfig from '../../common/config';
import { fetchComponentData, saveComponentToWorkFlow } from "../../../services/workFlowDiagramService";

const DebugComponent = () => {
  //Common for all component
  const [nodeKey, setNodeKey] = useState("");
  const [componentJson, setComponentJson] = useState(null);

  const [spName, setSpName] = useState("");
  const [spList, setSPList] = useState([]);

  //Get component Json on Load
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchComponentData(setNodeKey);
      setComponentJson(data);
    };
    fetchData();
  }, []);

  //Set component Json to fields on 'componentJson' update
  useEffect(() => {
    const setComponentData = (processData) => {
      //Set data to component fields
      var compObj = processData?.componentSteps[0];
      if (compObj) {
        setSpName(compObj.spname || "");
        const options = compObj.splist?.map((sp) => ({ value: sp, label: sp }));
        setSPList(options || []);
      }
    }

    setComponentData(componentJson);
  }, [componentJson]);


  // Function to update spname
  const updateDebugComponentJson = (data) => {
    const updatedData = { ...componentJson };
    if (updatedData.componentSteps && updatedData.componentSteps[0]) {
      updatedData.componentSteps[0].spname = data;
    }
    return updatedData;
  };

  const handleSave = () => {
    if (!spName) {
      message.error("Please select a stored procedure");
      return;
    }

    const compConfig = updateDebugComponentJson(spName);

    //This component default output line
    const linesData = { lines: null };
    const defaultLine1 = ComponentConfig.LINE_SUCCESS;
    //const defaultLine2 = ComponentConfig.LINE_FAIL;
    linesData.lines = [defaultLine1];

    //Common save function in all component    
    saveComponentToWorkFlow(nodeKey, compConfig, linesData);
  };

  return (
    <>
      <Card style={{ width: 400 }}>
        <Select
          value={spName || ""}
          placeholder="Select Stored Procedure"
          style={{ width: "100%", marginBottom: 16 }}
          onChange={(value) => setSpName(value)}
          options={spList}
        >
        </Select>

        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </Card >
    </>
  );
};

export default DebugComponent;
